import { getVersion } from '../../../utilities/version.util'
import Logger from '../../../services/logger.service'

const END_OF_SUPPORT_MAP_KEY = 'endOfSupportMap'
const MAX_SIZE_FOR_EOS_MAP = 4

export class EndOfSupportService {
  static getEosMessageForVersion = () => {
    const version = getVersion()
    const eosMap = EndOfSupportService.getEosMapFromLocalStorage()

    return eosMap.get(version)
  }

  static crudEndOfSupportForVersion = (eosMessage: string) => {
    const version = getVersion()

    const eosMap = EndOfSupportService.getEosMapFromLocalStorage()
    eosMap.set(version, eosMessage)

    // Keep the size of the map under control
    // Since maps are ordered in JS, we will always remove the oldest entries 1st
    if (eosMap.size > MAX_SIZE_FOR_EOS_MAP) {
      const keysToRemove = Array.from(eosMap.keys()).slice(0, eosMap.size - MAX_SIZE_FOR_EOS_MAP)
      for (const key of keysToRemove) {
        eosMap.delete(key)
        Logger.info(`Removed key: ${key} from ${END_OF_SUPPORT_MAP_KEY}`)
      }
    }

    localStorage.setItem(END_OF_SUPPORT_MAP_KEY, JSON.stringify(Array.from(eosMap.entries())))
    Logger.info(`EOS message: '${eosMessage}' set for version: ${version}`)
  }

  static removeEndOfSupportForVersion = () => {
    const version = getVersion()
    const eosMap = EndOfSupportService.getEosMapFromLocalStorage()
    const removed = eosMap.delete(version)

    if (removed) {
      localStorage.setItem(END_OF_SUPPORT_MAP_KEY, JSON.stringify(Array.from(eosMap.entries())))
      Logger.info(`Removed version: ${version} from ${END_OF_SUPPORT_MAP_KEY}`)
    }
  }

  static getEosMapFromLocalStorage = (): Map<string, string> => {
    const eosMapObjStr = localStorage.getItem(END_OF_SUPPORT_MAP_KEY)

    if (!eosMapObjStr) {
      return new Map<string, string>()
    }

    return new Map<string, string>(JSON.parse(eosMapObjStr))
  }
}
